text<template>
    <div class="form-group">
        <label for="country_code" class="control-label">{{ trans(label) }}</label>
        <select id="country_code" :required="isrequired" :name="named" v-model="value" class="form-control" v-on:change="updateValue($event.target.value)">
            <option v-if="default_msg.length > 0" :value="default_val">{{ default_msg }}</option>
            <option v-for="(name, val, index) in list" :value="val" :selected="value == val">{{ name }}</option>
        </select>
    </div>
</template>
<script>
    var countries = require('country-list')();
    export default{
        props: {
            id: { default: '' },
            name: { default: '' },
            label: { default: 'country' },
            value: { default: 'AU' },
            req: { default: '' },
            default_msg: { default: '--- Please Select ---' },
            default_val: { default: '' }
        },
        data: function() {
            return {
                list: countries.getData()
            };
        },
        created() {
            let list = {};
            $.each(this.list, function (index, value) {
                list[value.code] = value.name;
            });
            this.list = list;
        },
        computed: {
            isrequired() {
                return this.req === true;
            },
            named: function () {
                // Compute name depending on how deep it should be
                if (this.name == '') {
                    if(this.id == '') {
                        return this.label;
                    }
                    return this.id;
                }
                return this.name + '[' +  this.id + ']';
            }
        },
        methods: {
            updateValue: function (value) {
                // When the internal value changes, we $emit an event. Because this event is
                // named 'input', v-model will automatically update the parent value
                this.$emit('input', value);
            }
        }
    }
</script>
